import syncMaps from "./syncMaps";

class CompareMaps {
  constructor(a, b, container) {
    this._mapA = a;
    this._mapB = b;
    this._onDown = this._onDown.bind(this);
    this._onMove = this._onMove.bind(this);
    this._onUp = this._onUp.bind(this);
    this._swiper = document.createElement("div");
    this._swiper.className = "compare-swiper-vertical";

    this._controlContainer = document.createElement("div");
    this._controlContainer.className = "airsage-compare";
    this._controlContainer.appendChild(this._swiper);

    if (container instanceof Element && container.appendChild) {
      container.appendChild(this._controlContainer);
    } else {
      throw new Error("Invalid container specified. Must be CSS selector or HTML element.");
    }

    this._bounds = b.getContainer().getBoundingClientRect();
    this.setPosition(this._bounds.width / 2);

    syncMaps([a, b]);

    this._swiper.addEventListener("mousedown", this._onDown);
  }

  setPosition(x) {
    x = Math.min(x, this._bounds.width);
    const pos = `translate(${x}px, 0)`;
    this._controlContainer.style.transform = pos;
    this._controlContainer.style.WebkitTransform = pos;

    this._mapA.getContainer().style.clip = `rect(0, ${x}px, ${this._bounds.height}px, 0)`;
    this._mapB.getContainer().style.clip = `rect(0, 999em, ${this._bounds.height}px, ${x}px)`;
    this.currentPosition = x;
  }

  _onDown() {
    document.addEventListener("mousemove", this._onMove);
    document.addEventListener("mouseup", this._onUp);
  }

  _onMove(e) {
    e = e.touches ? e.touches[0] : e;
    let x = e.clientX - this._bounds.left;
    if (x < 0) x = 0;
    if (x > this._bounds.width) x = this._bounds.width;
    this.setPosition(x);
  }

  _onUp() {
    document.removeEventListener("mousemove", this._onMove);
    document.removeEventListener("mouseup", this._onUp);
  }
}

export default CompareMaps;
